/* unplugin-vue-components disabled */import script from "./message-image.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-image.vue?vue&type=script&lang=ts&setup=true"

import "./message-image.vue?vue&type=style&index=0&id=615271f6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-615271f6"]])

export default __exports__